module.exports = __webpack_public_path__ + "47d3774003c44ce7ac284fb74e4f8ac3.svg";